import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './LoadingSpinner.css';

export default function LoadingSpinner({ colorScheme, size }) {
  return (
    <div
      className={classNames(
        'loading-spinner',
        colorScheme ? `loading-spinner--${colorScheme}` : null,
        `loading-spinner--${size}`
      )}
    />
  );
}

LoadingSpinner.defaultProps = {
  colorScheme: null,
  size: 'small'
};

LoadingSpinner.propTypes = {
  colorScheme: PropTypes.oneOf(['red', 'green', 'blue']),
  size: PropTypes.oneOf(['small', 'large'])
};



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner.js